import { AdminLinks } from '@app/modules/admin/routing/links';
import { StreamerBoxLinks } from '@app/modules/streamer-box/routing/links';
import { AuditLinks } from './audit/components/links';
import { useIsContentAiEnabled } from './content-ai/hooks/useIsContentAiEnabled';
import { ContentAiLinks } from './content-ai/routing/links';
import { FragmentsLinks } from './fragments/routing/links';
import { LoggerLinks } from './logger/links';
import { SearchLinks } from './search/routing/links';

export function ModulesNavLinks() {
  return (
    <>
      <LoggerLinks />
      <FragmentsLinks />
      <AuditLinks />
      <StreamerBoxLinks />
      <SearchLinks />
      {useIsContentAiEnabled() && <ContentAiLinks />}
      <AdminLinks />
    </>
  );
}
